// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "subscriptionInfo-1Qcuf";
var _4 = "subscriptionInfo__title-3nr56";
var _5 = "subscription-3hlSV";
var _6 = "subscription__decor-M2g9M";
var _7 = "subscription__decorTitle-3w8Ho";
var _8 = "subscription__details-1TIKj";
var _9 = "subscription__detailsTitle-2wiud";
var _a = "subscription__detailsContent-2GISH";
var _b = "subscription__planName-1hzXF";
var _c = "subscription__endDate-2aUsi";
var _d = "subscription__planOptions-3RBsl";
var _e = "subscription__planOption-2BWSS";
export { _1 as "__esModule", _2 as "mobile", _3 as "subscriptionInfo", _4 as "subscriptionInfo__title", _5 as "subscription", _6 as "subscription__decor", _7 as "subscription__decorTitle", _8 as "subscription__details", _9 as "subscription__detailsTitle", _a as "subscription__detailsContent", _b as "subscription__planName", _c as "subscription__endDate", _d as "subscription__planOptions", _e as "subscription__planOption" }
export default { "__esModule": _1, "mobile": _2, "subscriptionInfo": _3, "subscriptionInfo__title": _4, "subscription": _5, "subscription__decor": _6, "subscription__decorTitle": _7, "subscription__details": _8, "subscription__detailsTitle": _9, "subscription__detailsContent": _a, "subscription__planName": _b, "subscription__endDate": _c, "subscription__planOptions": _d, "subscription__planOption": _e }
